import { DimensionInput } from './Objectives'

export const MAX_DIMENSIONS = 6

export const hasDuplicates = (dimensionInfo: DimensionInput[]) => {
  const dimensionTitles = dimensionInfo
    .map((dimension) => dimension.title)
    .filter((title) => title !== '')
  return new Set(dimensionTitles).size !== dimensionTitles.length
}
